import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { isArray, isEmptyObj } from "../class/utilityHelper";
import { userPermission } from "../interface/user";
import { AuthService } from "../service/auth.service";

@Injectable({
    providedIn: 'root'
})
export class PermissionGuard {
    constructor(private auth: AuthService) { }

    canActivateChild(
        route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const data: any = route.data.permission || {} as userPermission;
        if (route.data?.noCheckGuard) {
            return true;
        }
        const check_queryParam = route.data.queryParam || false;
        let res = false;
        if (data == undefined || isEmptyObj(data)) {
            return true;
        }
        const skipParams = ['my_profile', 'my_report', 'my_leave_quota', 'my_self'];
        if (skipParams.includes(route.queryParams.id) || skipParams.includes(route.queryParams.mode)) {
            if (this.auth.currentUserValue.staff_fk_id) {
                res = true;
            }
        } else {
            let moduleName = data.moduleName, actionName = data.actionName;
            const routeParams = isArray(route.queryParams) ? route.queryParams : [route.queryParams],
                resultPermission: boolean[] = [];
            routeParams.forEach((e: any) => {
                if (!isEmptyObj(route.queryParams)) {
                    if (check_queryParam && typeof check_queryParam == 'string') {
                        actionName = check_queryParam;
                    } else if (typeof check_queryParam == 'object' || isArray(typeof check_queryParam)) {
                        let selectedQuery = check_queryParam;
                        if (isArray(check_queryParam)) {
                            //check the option
                            selectedQuery = check_queryParam?.find(a => route.queryParams[a.key]);
                        }
                        if (selectedQuery?.key) {
                            if (selectedQuery.value) {
                                if (route.queryParams[selectedQuery.key] == selectedQuery.value || '') {
                                    moduleName = selectedQuery.moduleName || moduleName;
                                    actionName = selectedQuery.actionName;
                                }
                            } else {
                                moduleName = selectedQuery.moduleName;
                                actionName = selectedQuery.actionName;
                            }
                        }
                    }
                }
                resultPermission.push(this.auth.checkPermission(moduleName, actionName));
            });
            res = resultPermission.length ? resultPermission.some(value => value === true) : this.auth.checkPermission(moduleName, actionName);
        }
        if (!res) {
            this.auth.redirectToDenied();
        }
        return res;
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const data: any = route.data.permission || {} as userPermission;
        const check_queryParam = route.data.queryParam || false;
        if (data == undefined) {
            return true;
        }
        if (isEmptyObj(data)) {
            return false;
        }
        let res = false;
        const skipParams = ['my_profile'];
        if (skipParams.includes(route.queryParams.id)) {
            return true;
        }

        if (check_queryParam && !isEmptyObj(route.queryParams)) {
            res = this.auth.checkPermission(data.moduleName, route.data.queryParam);
        } else {
            res = this.auth.checkPermission(data.moduleName, data.actionName);
        }
        if (!res) {
            this.auth.redirectToDenied();
        }

        return true;
    }
}